module.exports = __webpack_public_path__ + "media/icons/tair-42b7fffc.svg";